import { render, staticRenderFns } from "./BenefitsSetups.vue?vue&type=template&id=c699a61c"
import script from "./BenefitsSetups.vue?vue&type=script&lang=js"
export * from "./BenefitsSetups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports